/**
 * Design System Getproof - Card Styles
 * Styles basés sur l'analyse du code existant
 */

export const cardStyles = {
  // Classes de base communes à toutes les cartes
  base: [
    // Layout
    'relative flex flex-col',
    
    // Background
    'bg-white',
    
    // Transitions
    'transition-all duration-200',
    
    // Overflow
    'overflow-hidden',
  ].join(' '),

  variants: {
    // Carte par défaut (comme dans SubscriptionManagerNew)
    default: [
      'border border-gray-200',
      'rounded-xl',
      'shadow-sm',
    ].join(' '),

    // Carte avec outline (border plus visible)
    outlined: [
      'border border-neutral-300',
      'rounded-xl',
      'shadow-none',
    ].join(' '),

    // Carte élevée (plus d'ombre)
    elevated: [
      'border border-gray-200',
      'rounded-xl', 
      'shadow-md',
    ].join(' '),

    // Carte sélectionnée (border turquoise comme dans le code)
    selected: [
      'border-2 border-[#40E0D0]',
      'rounded-2xl', // Plus arrondi quand sélectionné
      'shadow-sm',
    ].join(' '),
  },

  sizes: {
    sm: 'max-w-sm',
    md: 'max-w-md', 
    lg: 'max-w-lg',
  },

  padding: {
    none: 'p-0',
    sm: 'p-4',      // 16px
    md: 'p-5',      // 20px - Standard dans le code
    lg: 'p-6',      // 24px
  },

  // États hover (basé sur le code existant)
  hover: {
    default: 'hover:shadow-md hover:border-gray-300',
    outlined: 'hover:border-[#40E0D0] hover:bg-[#40E0D0]/5',
    elevated: 'hover:shadow-lg',
    selected: '', // Pas de hover sur selected
  },
};

export const cardHeaderStyles = {
  base: [
    'flex flex-col gap-1',
  ].join(' '),

  withActions: [
    'flex flex-row items-start justify-between',
  ].join(' '),

  title: [
    'text-black text-xl font-semibold font-["Bricolage_Grotesque"]',
  ].join(' '),

  subtitle: [
    'text-neutral-400 text-xs font-normal font-["Bricolage_Grotesque"]',
  ].join(' '),
};

export const cardContentStyles = {
  base: [
    'flex-1',
  ].join(' '),
};

export const cardFooterStyles = {
  base: [
    'flex items-center justify-between',
    'pt-4 mt-auto',
  ].join(' '),
};